import React from "react"
import PropTypes from "prop-types"
import Autosuggest from "react-autosuggest"
import FontAwesome from "react-fontawesome"
import { getAutosuggestOptions } from "../../helpers/sharedHelperFunctions"

class FindSearchInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      suggestions: [],
    }
  }

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase()

    return Array.from(
      new Set(getAutosuggestOptions(inputValue, this.props.allAssets))
    )
  }

  getSuggestionValue = suggestion => suggestion

  renderSuggestion = suggestion => {
    return <div>{suggestion}</div>
  }

  onChange = (event, { newValue }) => {
    if (newValue === "") {
      this.clearInput()
    } else {
      this.props.updateKeywords(newValue, false)
    }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    })
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    })
  }

  onSuggestionSelected = (event, { suggestion }) => {
    const selectedAsset = this.props.allAssets.find(a => a.name === suggestion)
      .name

    this.setState(
      {
        value: selectedAsset,
        suggestions: [],
      },
      () => {
        this.props.updateKeywords(this.props.keywords, true)
      }
    )
  }

  clearInput = () => {
    this.setState(
      {
        value: "",
        suggestions: [],
      },
      () => {
        this.props.updateKeywords("", this.props.searchOnEmptyInput)
      }
    )
  }

  render() {
    const inputProps = {
      placeholder: "All Assets",
      value: this.props.keywords,
      type: "search",
      id: "search",
      onChange: this.onChange,
      onBlur: this.onSubmit,
    }
    return (
      <div className="FindSearchInput">
        <label className="label no-margin-bottom" for="search">
          Find
        </label>
        <form
          onSubmit={e => {
            e.preventDefault()
            this.props.updateKeywords(this.props.keywords, true)
          }}
        >
          <Autosuggest
            suggestions={this.state.suggestions}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
            onSuggestionSelected={this.onSuggestionSelected}
            focusInputOnSuggestionClick={false}
          />
        </form>
        {this.props.keywords !== "" ? (
          <FontAwesome
            className="clearInput"
            onClick={this.clearInput}
            name={"times"}
          />
        ) : (
          ""
        )}
      </div>
    )
  }
}

FindSearchInput.propTypes = {
  allAssets: PropTypes.array.isRequired,
  keywords: PropTypes.string,
  updateKeywords: PropTypes.func.isRequired,
  searchOnEmptyInput: PropTypes.bool,
}

FindSearchInput.defaultProps = {
  keywords: "",
  allAssets: [],
  searchOnEmptyInput: true,
}

export default FindSearchInput
